import React from "react"
import { batch } from "@preact/signals-react"

import { AppCurrencyAutocomplete } from "@components"
import { BACKEND_APIS } from "@constants"
import { currency, currencyCode, errors } from "@signals"


export default function CurrencyAutocomplete({ onFinishAjax: onFinishAjaxProp, ...props }) {
    return <AppCurrencyAutocomplete
		disableClearable
		value={currency.value}
		error={errors.value?.currency}
		onChange={e => currency.value = e.target.value}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/execution/options/currencies`}
		onFinishAjax={options => {
			batch(() => {
				const defaultOption = options.find(a => a.selected)
				const currentExists = options.find(a => a.value === currency.value)
				if (currency.value == null || !currentExists) {
					currency.value = defaultOption?.value ?? null
				}
				const currentOption = options.find(a => a.value === currency.value) ?? defaultOption
				currencyCode.value = currentOption?.label ?? null
			})
			onFinishAjaxProp?.(options)
		}}
		{...props}
	/>
}